import removeTableFromStore from '../actions/store-factory/removeTableFromStore';
import { removeSearchTableFromStore } from 'owa-mail-search';
import { removeSearchTableFromStore as removeSearchTableFromStoreNext } from 'owa-mail-search-next-lazy';
import { createLazyOrchestrator } from 'owa-bundling';

export default createLazyOrchestrator(
    removeSearchTableFromStore,
    'clone_removeSearchTableFromStore',
    actionMessage => {
        removeTableFromStore(actionMessage.tableViewId);
    }
);

export const removeSearchTableFromStoreNextOrchestrator = createLazyOrchestrator(
    removeSearchTableFromStoreNext,
    'clone_removeSearchTableFromStoreNext',
    actionMessage => {
        removeTableFromStore(actionMessage.tableViewId);
    }
);
